import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const steps = [
  { num: '1', icon: 'ri-search-line' },
  { num: '2', icon: 'ri-file-list-3-line' },
  { num: '3', icon: 'ri-hammer-line' },
  { num: '4', icon: 'ri-fire-line' },
  { num: '5', icon: 'ri-shield-check-line' },
];

export default function Process() {
  const { t } = useTranslation('toitplat');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="process" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('process_h2')}
          </h2>
        </div>

        {/* Desktop horizontal */}
        <div className="hidden md:block relative">
          <div className="absolute top-10 left-[10%] right-[10%] h-0.5 bg-copper/20" />
          <div className="grid grid-cols-5 gap-4">
            {steps.map((step, idx) => (
              <div
                key={idx}
                className={`text-center transition-all duration-700 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${idx * 120 + 200}ms` }}
              >
                <div className="relative inline-flex items-center justify-center w-20 h-20 rounded-full bg-white border-2 border-copper shadow-sm mb-5 z-10">
                  <span className="font-manrope font-bold text-copper text-xl">{step.num}</span>
                </div>
                <h3 className="font-manrope font-bold text-slate-primary text-sm mb-1">
                  {t(`process_step${idx + 1}_title`)}
                </h3>
                {t(`process_step${idx + 1}_sub`) !== `process_step${idx + 1}_sub` && (
                  <span className="inline-block text-copper text-xs font-semibold bg-copper/10 px-2 py-0.5 rounded-full mb-1">
                    {t(`process_step${idx + 1}_sub`)}
                  </span>
                )}
                <p className="text-slate-primary/60 text-xs leading-relaxed px-1">
                  {t(`process_step${idx + 1}_desc`)}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile vertical */}
        <div className="md:hidden space-y-8 relative">
          <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-copper/20" />
          {steps.map((step, idx) => (
            <div
              key={idx}
              className={`relative pl-16 transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 120 + 200}ms` }}
            >
              <div className="absolute left-0 top-0 w-12 h-12 rounded-full bg-white border-2 border-copper flex items-center justify-center shadow-sm">
                <span className="font-manrope font-bold text-copper text-lg">{step.num}</span>
              </div>
              <h3 className="font-manrope font-bold text-slate-primary text-sm mb-0.5">
                {t(`process_step${idx + 1}_title`)}
              </h3>
              {t(`process_step${idx + 1}_sub`) !== `process_step${idx + 1}_sub` && (
                <span className="inline-block text-copper text-xs font-semibold bg-copper/10 px-2 py-0.5 rounded-full mb-1">
                  {t(`process_step${idx + 1}_sub`)}
                </span>
              )}
              <p className="text-slate-primary/60 text-sm leading-relaxed">
                {t(`process_step${idx + 1}_desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}